<section class="section-title">

    <div class="section-title-image">
        <img class="device-image" src="assets/img/user.png" />
    </div>

    <div class="section-title-text">
        <h1 i18n="@@requests_title">Richieste</h1>
    </div>

</section>


<section class="section-content">

    <div class="buttons-container">

        <a *ngIf="canUserManageRequestTypes" (click)="openRequestTypes()" class="button">
            <ng-container i18n="@@requests_permission_types">Tipologie permessi</ng-container> <span>
                <fa-icon icon="list"></fa-icon>
            </span>
        </a>

        <a *ngIf="isUserAlias && canUserUserEdit" (click)="addUser()" class="button">
            <ng-container i18n="@@requests_add_user">Aggiungi abbonamento</ng-container> <span>
                <fa-icon icon="user"></fa-icon>
            </span>
        </a>

    </div>


    <p i18n="@@requests_filters">Filtri: </p>

    <div fxLayout="row" fxLayoutAlign="space-between center">

        <div id="radiobuttons-div" fxFlex="60">
            <mat-radio-group id="radiobuttons">
                <mat-radio-button class="mat-radio-button" value="1" i18n="@@requests_all"
                    (change)="setRequestsFilter($event)" [checked]="true">Tutte
                </mat-radio-button>
                <mat-radio-button class="mat-radio-button" value="2" (change)="setRequestsFilter($event)"
                    i18n="@@requests_pending">In sospeso
                </mat-radio-button>
                <mat-radio-button class="mat-radio-button-custom" value="3" (change)="setRequestsFilter($event)"
                    i18n="@@requests_accepted">
                    Accettate</mat-radio-button>
                <mat-radio-button class="mat-radio-button-custom" value="4" (change)="setRequestsFilter($event)"
                    i18n="@@requests_rejected">
                    Rifiutate</mat-radio-button>
            </mat-radio-group>
        </div>

        <div id="filter-div" fxFlex="4">
            <p i18n="@@operationLog_filter">Filtra: </p>
        </div>

        <div fxFlex="25" class="table-filter">
            <input id="filter-input" (keyup)="onKey($event)" />
        </div>

    </div>

    <br>

    <div class="table-container">
        <!-- fixed-table -->
        <table mat-table matSort #requeststable [dataSource]="tableRequestsList" class="simple-table ">

            <ng-container matColumnDef="date">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@requests_date" style="width: 17%;">
                    Data richiesta
                </th>
                <td mat-cell *matCellDef="let element" class="td-medium"> {{ element.tableDate }} </td>
            </ng-container>

            <ng-container matColumnDef="firstname">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@requests_firstname" style="width: 14%;">
                    Nome
                </th>
                <td mat-cell *matCellDef="let element" class="td-medium"> {{ element.firstname }} </td>
            </ng-container>

            <ng-container matColumnDef="lastname">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@requests_lastname" style="width: 14%;">
                    Cognome
                </th>
                <td mat-cell *matCellDef="let element" class="td-medium"> {{ element.lastname }} </td>
            </ng-container>

            <ng-container matColumnDef="email">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@requests_email" style="width: 15%;">Email
                </th>
                <td mat-cell *matCellDef="let element" class="td-medium"> {{ element.email }} </td>
            </ng-container>

            <ng-container matColumnDef="notes">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@requests_notes" style="width: 30%;">Note
                </th>
                <td mat-cell *matCellDef="let element" class="td-notes">
                    <!-- <div style="max-width: 730px; overflow: auto;">
                        {{ element.notes }}
                    </div> -->
                    {{ element.notes }}
                </td>
            </ng-container>

            <!-- <ng-container matColumnDef="acceptRejectNotes">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@requests_acceptRejectNotes" style="width: 25%;">Messaggio per il richiedente 
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.acceptRejectNotes }} </td>
            </ng-container> -->

            <ng-container matColumnDef="state">
                <th mat-header-cell mat-sort-header *matHeaderCellDef i18n="@@requests_state" style="width: 9%;">Stato
                </th>
                <td mat-cell *matCellDef="let element"> {{ element.state }} </td>
            </ng-container>

            <ng-container matColumnDef="viewRequest">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let element" class="td-10">
                    <!-- *ngIf="!element.rejected && !element.accepted" -->
                    <fa-icon icon="magnifying-glass" class="float-right padding-5 icon-clickable"
                        (click)="onRowClicked(element)"></fa-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>

    </div>

</section>

<app-loading-screen #requestsloader></app-loading-screen>